import { useEffect } from "react";
import Course from "src/components/Course";
import { queryClient } from "src/queryClient";

export function CourseView() {
	useEffect(() => {
		return () => {
			queryClient.removeQueries({ queryKey: ["courses"] });
			queryClient.removeQueries({ queryKey: ["courses-templates"] });
		};
	}, []);

	return <Course />;
}
